import { Route } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import ProtectedRouteV2 from "./ProtectedRouteV2";

// 📄 Pages
import PromotionListPage from "../pages/Promotions/PromotionListPage";
import PromotionEditorPage from "../pages/Promotions/PromotionEditorPage";
import DiscountRulesPage from "../pages/Promotions/DiscountRulesPage";
import ProductAssignmentPage from "../pages/Promotions/ProductAssignmentPage";
import PromotionRuleComposerPage from "../pages/Promotions/PromotionRuleComposerPage";
import PromotionCalendarPage from "../pages/Promotions/PromotionCalendarPage";
import MarketingDashboardPage from "../pages/Promotions/MarketingDashboardPage";

const promotionsRoutes = (
  <Route element={<ProtectedRouteV2 />}>

    {/* 📌 Lista de promociones */}
    <Route
      path="/marketing/promotions"
      element={
        <>
          <PageTitle title="Promociones | Codenova POS" />
          <PromotionListPage />
        </>
      }
    />

    {/* ✍️ Editor de Promociones */}
    <Route
      path="/marketing/promotions/editor"
      element={
        <>
          <PageTitle title="Editor de Promociones | Codenova POS" />
          <PromotionEditorPage />
        </>
      }
    />

    {/* 🧮 Reglas matemáticas */}
    <Route
      path="/marketing/discount-rules"
      element={
        <>
          <PageTitle title="Reglas de Descuento | Codenova POS" />
          <DiscountRulesPage />
        </>
      }
    />

    {/* 🔗 Asignación de productos */}
    <Route
      path="/marketing/product-promotions"
      element={
        <>
          <PageTitle title="Asignación de Productos | Codenova POS" />
          <ProductAssignmentPage />
        </>
      }
    />

    {/* 🧠 Composición de reglas */}
    <Route
      path="/marketing/promotion-rules"
      element={
        <>
          <PageTitle title="Composición de Reglas | Codenova POS" />
          <PromotionRuleComposerPage />
        </>
      }
    />

    {/* 📅 Calendario */}
    <Route
      path="/marketing/calendar"
      element={
        <>
          <PageTitle title="Calendario de Promociones | Codenova POS" />
          <PromotionCalendarPage />
        </>
      }
    />

    {/* 📊 Dashboard Marketing */}
    <Route
      path="/marketing/dashboard"
      element={
        <>
          <PageTitle title="Dashboard Marketing | Codenova POS" />
          <MarketingDashboardPage />
        </>
      }
    />

  </Route>
);

export default promotionsRoutes;
